var AppEnvironmentEnum;
(function (AppEnvironmentEnum) {
    AppEnvironmentEnum["PRODUCTION"] = "production";
    AppEnvironmentEnum["STAGING"] = "staging";
    AppEnvironmentEnum["STAGING2"] = "staging2";
    AppEnvironmentEnum["LOCAL"] = "local";
})(AppEnvironmentEnum || (AppEnvironmentEnum = {}));
export default AppEnvironmentEnum;
//# sourceMappingURL=AppEnvironmentEnum.js.map